import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { motion } from "framer-motion";
import CardGrid from "../../components/elements/CardGrid";

interface AuthContainerProps {
  children: any;
  title: string;
}

const AuthContainer = ({ children, title }: AuthContainerProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5, originY: "100px" }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.7 }}
    >
      <Grid container>
        <Grid
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          flexWrap={"nowrap"}
          container
          item
          xs={12}
          gap={4}
        >
          <CardGrid
            padding={4}
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              border: "none",
            }}
          >
            <Box display={"flex"}>
              <Typography
                sx={{
                  fontSize: 50,
                }}
                fontWeight={"bold"}
                color={"primary"}
              >
                {title}
              </Typography>
            </Box>
          </CardGrid>
        </Grid>
        <Grid
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          flexWrap={"nowrap"}
          container
          item
          xs={12}
          gap={4}
        >
          <CardGrid
            padding={2}
            background="white"
            xs={5}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            {children}
          </CardGrid>
        </Grid>
      </Grid>
    </motion.div>
  );
};

export default AuthContainer;
